<template>
  <b-card no-body class="p-3">
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-form
        class="p-2"
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-tabs v-if="settings" v-model="tabIndex">
          <b-tab
            v-for="setting in settings"
            :key="'tab-' + setting.module"
            :title="setting.module"
          >
            <template v-if="setting.settings.length > 0">
              <validation-provider
                v-for="setts in setting.settings"
                :key="'set-tab' + setting.module + '-' + setts.slug"
                #default="validationContext"
                :name="setts.slug"
                :rules="setts.is_required ? 'required' : 'min:0'"
              >
                <b-form-group :label="setts.title" :label-for="setts.slug">
                  <b-form-input
                    v-if="setts.type == 'text' || setts.type == 'password'"
                    :id="setts.slug"
                    v-model="setts.value"
                    :type="setts.type"
                    autofocus
                    :state="getValidationState(validationContext)"
                    trim
                    autocomplete="false"
                    :placeholder="setts.title"
                  />
                  <b-form-textarea
                    v-if="setts.type == 'textarea'"
                    :id="setts.slug"
                    v-model="setts.value"
                    autofocus
                    :state="getValidationState(validationContext)"
                    trim
                    :placeholder="setts.title"
                  />

                  <b-form-checkbox
                    v-if="setts.type == 'checkbox'"
                    checked="true"
                    class="custom-control-success"
                    :id="setts.slug"
                    v-model="setts.value"
                    switch
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <UploadLogo
                  v-if="setts.type == 'image'"
                  :imgLogo="setts.value"
                  @upload-logo="uploadLogo"
                />
              </validation-provider>
            </template>
          </b-tab>
        </b-tabs>
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
          >
            Save
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </b-card>
</template>
<script>
//send-grid user, pass
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BFormInvalidFeedback,
  BButton,
  BTabs,
  BTab,
} from "bootstrap-vue";

import {
  BCard,
  BCardText,
  BMedia,
  BMediaAside,
  BMediaBody,
  BAvatar,
  BImg,
  BLink,
  BFormFile,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import { $themeConfig } from '@themeConfig'
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref } from "@vue/composition-api";
import { required, alphaNum, email, password, confirmed } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "./settingsStoreModule";
import UploadLogo from "../general/UploadLogo.vue"

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BFormInvalidFeedback,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BImg,
    BLink,
    BFormFile,
    BListGroup,
    BListGroupItem,
    ValidationProvider,
    ValidationObserver,
    UploadLogo,
  },
  directives: {
    Ripple,
  },
  setup() {
    const {  appRef } = $themeConfig.app
    const refInputEl = ref([]);
    const toast = useToast();
    const settings = ref([]);
    const tabIndex = ref(0);
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const imgLogo = ref('')

    const PREMISSIONS_SETTINGS_STORE_MODULE_NAME = "permissions-settings";
    if (!store.hasModule(PREMISSIONS_SETTINGS_STORE_MODULE_NAME))
      store.registerModule(
        PREMISSIONS_SETTINGS_STORE_MODULE_NAME,
        settingsStoreModule
      );
    onUnmounted(() => {
      if (store.hasModule(PREMISSIONS_SETTINGS_STORE_MODULE_NAME))
        store.unregisterModule(PREMISSIONS_SETTINGS_STORE_MODULE_NAME);
    });

    store.dispatch('permissions-settings/fetchData', {
        sites_id: getLocalSite.id
      })
      .then(response => {
        settings.value  = response.data.data;
      })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching data' list",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      });

    const uploadLogo = (file) => {
      console.log(file)
      refInputEl.value = file
    }

    const resetData = () => {
            //Data.value = JSON.parse(JSON.stringify(blankData))
        }
    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetData);

    // const getData = () =>{
    //   // refPreviewEl.value.src = require("@/assets/images/no-image.png");

    //   store.dispatch('permissions-settings/fetchData', {
    //     sites_id: getLocalSite.id
    //   })
    //   .then(response => {
    //     settings.value  = response.data.data;
    //     console.log('response',settings.value);
    //   })
    //   .catch(() => {
    //     toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: "Error fetching invoices' list",
    //         icon: 'AlertTriangleIcon',
    //         variant: 'danger',
    //       },
    //     })
    //   });
    // }

    // getData();
    const onSubmit = () => {
        let formData = new FormData();

        formData.append('path', `/var/www/html/uploadfiles/uploads/${appRef}/amenities/`);
        formData.append('savepath', `uploads/${appRef}/allergies/`);

        store.dispatch('permissions-settings/updateData', {
          sites_id: getLocalSite.id,
          data: settings.value,
          formData: formData
        })
        .then((res) => {
            if(res.data.success){
            toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                title: `Success`,
                icon: 'BellIcon',
                variant: 'success',
                text: `${res.data.message}`,
                },
            });
            }else{
            toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                title: `Error`,
                icon: 'BellIcon',
                variant: 'danger',
                text: `${res.data.message}`,
                },
            });
        
            
            }
        
        })
      }      

    return {
      settings,
      onSubmit,
      tabIndex,
      refFormObserver,
      getValidationState,
      resetForm,
      refInputEl,
      tabIndex,
      settings,
      onSubmit,
      resetData,
      uploadLogo,
      imgLogo,
    };
  },
};
</script>
